export const addEmptySpacesToParam = (param: string): string => param.replace(/(==|>=|<=|!=|<|>)/g, " $1 ")
